export default (data, dt) => {
    if (!data) {
        return null;
    }

    return {
        content: dt("content", data.translations),
        admin_url: data.adminUrl,
    };
};